import React, { useMemo } from 'react'
import { numCol, strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import CommonScreen from '../admin/component/CommonScreen'
import { yesNoMap } from '../core/utils'
import * as api from '../api/pgads'

const title = 'Additional Monthly Tags'

const Card95ExtSpec = () => {
  const headerWithFormatter = useMemo(
    _ =>
      Card95ExtSpecHeaders.map(h =>
        h.ident.includes('readonly')
          ? {
              ...h,
              ...toSelectionColProps(yesNoMap),
            }
          : h
      ),
    []
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={headerWithFormatter}
      saveTask={api.saveCard95ExtensionSpec}
      retrieveTask={api.getCard95ExtensionSpec}
      autoRetrieve
      allowInsert={false}
      withDelete={false}
      sortOptions={Card95ExtSpecHeaders}
      widthOffset={100}
      heightOffset={270}
      autoFixColByKey={false}
      headerRowHeight={60}
    />
  )
}

export default Card95ExtSpec

export const Card95ExtSpecHeaders = [
  strCol({
    ident: 'header1',
    display: 'Header 1',
    alignment: 'left',
    width: 130,
    ellipsis: true,
  }),
  numCol({
    ident: 'minVal1',
    display: 'Min-Val 1',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal1',
    display: 'Max-Val 1',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header2',
    display: 'Header 2',
    alignment: 'left',
    width: 130,
  }),
  numCol({
    ident: 'minVal2',
    display: 'Min-Val 2',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal2',
    display: 'Max-Val 2',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header3',
    display: 'Header 3',
    alignment: 'left',
    width: 130,
  }),
  numCol({
    ident: 'minVal3',
    display: 'Min-Val 3',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal3',
    display: 'Max-Val 3',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header4',
    display: 'Header 4',
    alignment: 'left',
    width: 130,
  }),
  numCol({
    ident: 'minVal4',
    display: 'Min-Val 4',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal4',
    display: 'Max-Val 4',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header5',
    display: 'Header 5',
    alignment: 'left',
    width: 130,
  }),
  numCol({
    ident: 'minVal5',
    display: 'Min-Val 5',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal5',
    display: 'Max-Val 5',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header6',
    display: 'Header 6',
    alignment: 'left',
    width: 130,
  }),
  numCol({
    ident: 'minVal6',
    display: 'Min-Val 6',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal6',
    display: 'Max-Val 6',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header7',
    display: 'Header 7',
    alignment: 'left',
    width: 130,
  }),
  numCol({
    ident: 'minVal7',
    display: 'Min-Val 7',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal7',
    display: 'Max-Val 7',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header8',
    display: 'Header 8',
    alignment: 'left',
    width: 130,
  }),
  numCol({
    ident: 'minVal8',
    display: 'Min-Val 8',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal8',
    display: 'Max-Val 8',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header9',
    display: 'Header 9',
    alignment: 'left',
    width: 130,
  }),
  numCol({
    ident: 'minVal9',
    display: 'Min-Val 9',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal9',
    display: 'Max-Val 9',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header10',
    display: 'Header 10',
    alignment: 'left',
    width: 130,
  }),
  numCol({
    ident: 'minVal10',
    display: 'Min-Val 10',
    displayFormat: '0',
    alignment: 'right',
  }),
  numCol({
    ident: 'maxVal10',
    display: 'Max-Val 10',
    displayFormat: '0',
    alignment: 'right',
  }),
  strCol({
    ident: 'header11',
    display: 'Header 11',
    alignment: 'left',
    width: 130,
  }),
  strCol({
    ident: 'header12',
    display: 'Header 12',
    alignment: 'left',
    width: 130,
  }),
  strCol({
    ident: 'header13',
    display: 'Header 13',
    alignment: 'left',
    width: 130,
  }),
  strCol({
    ident: 'header14',
    display: 'Header 14',
    alignment: 'left',
    width: 130,
  }),
  strCol({
    ident: 'header15',
    display: 'Header 15',
    alignment: 'left',
    width: 130,
  }),
]
